import { render, staticRenderFns } from "./ApprovalMilkRepaymentDetail.vue?vue&type=template&id=63d8e994&scoped=true&"
import script from "./ApprovalMilkRepaymentDetail.vue?vue&type=script&lang=js&"
export * from "./ApprovalMilkRepaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalMilkRepaymentDetail.vue?vue&type=style&index=0&id=63d8e994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d8e994",
  null
  
)

export default component.exports